/**
 * API Endpoints for Personnel domain
 *
 * Constants defining the API routes for personnel-related resources.
 * Centralizes endpoint definitions to avoid hardcoded strings.
 */
export const PERSONNEL_API_ENDPOINTS = {
  EMPLOYEES: {
    USERS: '/v2/users/',
    LIST: '/v2/users/',
    GET: '/v2/users/{userUuid}',
    CREATE: '/v2/users/',
    UPDATE: '/v2/users/{userUuid}/',
    DELETE: '/v2/users/{userUuid}/',
    PIN_GENERATE: '/v2/pin/generate',
    PIN_VALIDATE: '/v2/pin/validate/',
    BULK_DELETE: '/v2/users/bulk-delete/',
  },
  NOTIFICATION_PREFERENCES: {
    CONFIG: '/v2/notification-preferences/config/',
  },
  STORES: {
    LIST: '/v2/stores',
  },
  ROLES: {
    LIST: '/v2/roles',
    GET: '/v2/roles/{roleUuid}',
    CREATE: '/v2/roles',
    UPDATE: '/v2/roles/{roleUuid}',
    DELETE: '/v2/roles/{roleUuid}',
    DUPLICATE: '/v2/roles/{roleUuid}/duplicate',
    CONFIGURATION: '/v2/roles/{roleUuid}/role-configurations',
  },
  PROFILES: {
    GET: '/v2/profiles',
  },
};
